import * as Bixby from '$/core';
import { LoginClearPreloadedData } from '$/store/login/types';

export interface CompanyState {
  isLoading: boolean;
  error?: Bixby.Models.BixbyError;
  currentCompany?: Bixby.Models.AdminCompany;
  companies: Bixby.Models.AdminCompanySlim[] | undefined;
  isAddingCompanyToClient?: boolean;
  addingCompanyToClientError?: Bixby.Models.BixbyError;
  isDeletingCompanyFromClient?: boolean;
  deletingCompanyFromClientError?: Bixby.Models.BixbyError;
  isGeneratingPrimer?: boolean;
  isGeneratingTearSheet?: boolean;
  isAddingClientCompanyTask?: boolean;
  isAddingPublicCompanyTask?: boolean;
  isLoadingDocumentAnnouncement: boolean;
  isLoadingMostRecentCompanyTask: boolean;
  mostRecentCompanyTaskError?: Bixby.Models.BixbyError;
  mostRecentCompanyTask?: Bixby.Models.ClientCompanyTask;
  isImportingCompanies?: boolean;
  importCompaniesError?: Bixby.Models.BixbyError;
  isImportingLFIIds?: boolean;
  importLFIIdsError?: Bixby.Models.BixbyError;
}

export const ADD_CLIENT_COMPANY_TASK = 'ADD_CLIENT_COMPANY_TASK';
export const ADD_CLIENT_COMPANY_TASK_SUCCESS = 'ADD_CLIENT_COMPANY_TASK_SUCCESS';
export const ADD_CLIENT_COMPANY_TASK_FAILURE = 'ADD_CLIENT_COMPANY_TASK_FAILURE';
export const ADD_PUBLIC_COMPANY_TASK = 'ADD_PUBLIC_COMPANY_TASK';
export const ADD_PUBLIC_COMPANY_TASK_SUCCESS = 'ADD_PUBLIC_COMPANY_TASK_SUCCESS';
export const ADD_PUBLIC_COMPANY_TASK_FAILURE = 'ADD_PUBLIC_COMPANY_TASK_FAILURE';
export const COMPANIES_LOADING = 'COMPANIES_LOADING';
export const COMPANIES_FAILURE = 'COMPANIES_FAILURE';
export const COMPANIES_SUCCESS = 'COMPANIES_SUCCESS';
export const GET_COMPANY = 'GET_COMPANY';
export const SET_CURRENT_COMPANY = 'SET_CURRENT_COMPANY';
export const CREATE_COMPANY = 'CREATE_COMPANY';
export const REMOVE_COMPANY = 'REMOVE_COMPANY';
export const COMPANY_LOADING = 'COMPANY_LOADING';
export const COMPANY_ERROR = 'COMPANY_ERROR';
export const COMPANIES_CLEAR = 'COMPANIES_CLEAR';
export const ADD_CLIENT_COMPANY = 'ADD_CLIENT_COMPANY';
export const ADD_CLIENT_COMPANY_SUCCESS = 'ADD_CLIENT_COMPANY_SUCCESS';
export const ADD_CLIENT_COMPANY_FAILURE = 'ADD_CLIENT_COMPANY_FAILURE';
export const DELETE_CLIENT_COMPANY = 'DELETE_CLIENTCOMPANY';
export const DELETE_CLIENT_COMPANY_SUCCESS = 'DELETE_CLIENT_COMPANY_SUCCESS';
export const DELETE_CLIENT_COMPANY_FAILURE = 'DELETE_CLIENT_COMPANY_FAILURE';
export const GENERATE_PRIMER = 'GENERATE_PRIMER';
export const GENERATE_PRIMER_SUCCESS = 'GENERATE_PRIMER_SUCCESS';
export const GENERATE_PRIMER_FAILURE = 'GENERATE_PRIMER_FAILURE';
export const GENERATE_TEARSHEET = 'GENERATE_TEARSHEET';
export const GENERATE_TEARSHEET_SUCCESS = 'GENERATE_TEARSHEET_SUCCESS';
export const GENERATE_TEARSHEET_FAILURE = 'GENERATE_TEARSHEET_FAILURE';
export const DOCUMENT_ANNOUNCEMENT_LOADING = 'DOCUMENT_ANNOUNCEMENT_LOADING';
export const DOCUMENT_ANNOUNCEMENT_SUCCESS = 'DOCUMENT_ANNOUNCEMENT_SUCCESS';
export const DOCUMENT_ANNOUNCEMENT_FAILURE = 'DOCUMENT_ANNOUNCEMENT_FAILURE';
export const MOST_RECENT_COMPANY_TASK_LOADING = 'MOST_RECENT_COMPANY_TASK_LOADING';
export const MOST_RECENT_COMPANY_TASK_SUCCESS = 'MOST_RECENT_COMPANY_TASK_SUCCESS';
export const MOST_RECENT_COMPANY_TASK_FAILURE = 'MOST_RECENT_COMPANY_TASK_FAILURE';
export const IMPORT_COMPANIES = 'IMPORT_COMPANIES';
export const IMPORT_COMPANIES_SUCCESS = 'IMPORT_COMPANIES_SUCCESS';
export const IMPORT_COMPANIES_FAILURE = 'IMPORT_COMPANIES_FAILURE';
export const IMPORT_LFI_IDS = 'IMPORT_LFI_IDS';
export const IMPORT_LFI_IDS_SUCCESS = 'IMPORT_LFI_IDS_SUCCESS';
export const IMPORT_LFI_IDS_FAILURE = 'IMPORT_LFI_IDS_FAILURE';

interface CompaniesLoading extends Bixby.Models.BixbyAction<undefined, typeof COMPANIES_LOADING> {
  type: typeof COMPANIES_LOADING;
}

interface CompaniesSuccess extends Bixby.Models.BixbyAction<Bixby.Models.AdminCompanySlim[], typeof COMPANIES_SUCCESS> {
  type: typeof COMPANIES_SUCCESS;
  payload: Bixby.Models.AdminCompanySlim[];
}

interface CompaniesFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof COMPANIES_FAILURE> {
  type: typeof COMPANIES_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface CompaniesClear extends Bixby.Models.BixbyAction<undefined, typeof COMPANIES_CLEAR> {
  type: typeof COMPANIES_CLEAR;
}

interface SetCurrentCompany extends Bixby.Models.BixbyAction<Bixby.Models.AdminCompany, typeof SET_CURRENT_COMPANY> {
  type: typeof SET_CURRENT_COMPANY;
  payload: Bixby.Models.AdminCompany;
}

interface CreateCompany extends Bixby.Models.BixbyAction<Bixby.Models.AdminCompany, typeof CREATE_COMPANY> {
  type: typeof CREATE_COMPANY;
  payload: Bixby.Models.AdminCompany;
}

interface RemoveCompany extends Bixby.Models.BixbyAction<string, typeof REMOVE_COMPANY> {
  type: typeof REMOVE_COMPANY;
  payload: string;
}

interface CompanyLoading extends Bixby.Models.BixbyAction<undefined, typeof COMPANY_LOADING> {
  type: typeof COMPANY_LOADING;
}

interface CompanyError extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof COMPANY_ERROR> {
  type: typeof COMPANY_ERROR;
  payload: Bixby.Models.BixbyError;
}

interface AddClientCompany extends Bixby.Models.BixbyAction<undefined, typeof ADD_CLIENT_COMPANY> {
  type: typeof ADD_CLIENT_COMPANY;
}

interface AddClientCompanySuccess extends Bixby.Models.BixbyAction<boolean, typeof ADD_CLIENT_COMPANY_SUCCESS> {
  type: typeof ADD_CLIENT_COMPANY_SUCCESS;
  payload: boolean;
}

interface AddClientCompanyFailure extends Bixby.Models.BixbyAction<undefined, typeof ADD_CLIENT_COMPANY_FAILURE> {
  type: typeof ADD_CLIENT_COMPANY_FAILURE;
}

interface AddClientCompanyTask extends Bixby.Models.BixbyAction<undefined, typeof ADD_CLIENT_COMPANY_TASK> {
  type: typeof ADD_CLIENT_COMPANY_TASK;
}

interface AddClientCompanyTaskSuccess
  extends Bixby.Models.BixbyAction<boolean, typeof ADD_CLIENT_COMPANY_TASK_SUCCESS> {
  type: typeof ADD_CLIENT_COMPANY_TASK_SUCCESS;
  payload: boolean;
}

interface AddClientCompanyTaskFailure
  extends Bixby.Models.BixbyAction<undefined, typeof ADD_CLIENT_COMPANY_TASK_FAILURE> {
  type: typeof ADD_CLIENT_COMPANY_TASK_FAILURE;
}

interface AddPublicCompanyTask extends Bixby.Models.BixbyAction<undefined, typeof ADD_PUBLIC_COMPANY_TASK> {
  type: typeof ADD_PUBLIC_COMPANY_TASK;
}

interface AddPublicCompanyTaskSuccess
  extends Bixby.Models.BixbyAction<boolean, typeof ADD_PUBLIC_COMPANY_TASK_SUCCESS> {
  type: typeof ADD_PUBLIC_COMPANY_TASK_SUCCESS;
  payload: boolean;
}

interface AddPublicCompanyTaskFailure
  extends Bixby.Models.BixbyAction<undefined, typeof ADD_PUBLIC_COMPANY_TASK_FAILURE> {
  type: typeof ADD_PUBLIC_COMPANY_TASK_FAILURE;
}

interface DeleteClientCompany extends Bixby.Models.BixbyAction<undefined, typeof DELETE_CLIENT_COMPANY> {
  type: typeof DELETE_CLIENT_COMPANY;
}

interface DeleteClientCompanySuccess extends Bixby.Models.BixbyAction<boolean, typeof DELETE_CLIENT_COMPANY_SUCCESS> {
  type: typeof DELETE_CLIENT_COMPANY_SUCCESS;
  payload: boolean;
}

interface DeleteClientCompanyFailure extends Bixby.Models.BixbyAction<undefined, typeof DELETE_CLIENT_COMPANY_FAILURE> {
  type: typeof DELETE_CLIENT_COMPANY_FAILURE;
}

interface GeneratePrimer extends Bixby.Models.BixbyAction<undefined, typeof GENERATE_PRIMER> {
  type: typeof GENERATE_PRIMER;
}

interface GeneratePrimerSuccess extends Bixby.Models.BixbyAction<boolean, typeof GENERATE_PRIMER_SUCCESS> {
  type: typeof GENERATE_PRIMER_SUCCESS;
  payload: boolean;
}

interface GeneratePrimerFailure extends Bixby.Models.BixbyAction<undefined, typeof GENERATE_PRIMER_FAILURE> {
  type: typeof GENERATE_PRIMER_FAILURE;
}

interface GenerateTearSheet extends Bixby.Models.BixbyAction<undefined, typeof GENERATE_TEARSHEET> {
  type: typeof GENERATE_TEARSHEET;
}

interface GenerateTearSheetSuccess extends Bixby.Models.BixbyAction<boolean, typeof GENERATE_TEARSHEET_SUCCESS> {
  type: typeof GENERATE_TEARSHEET_SUCCESS;
  payload: boolean;
}

interface GenerateTearSheetFailure extends Bixby.Models.BixbyAction<undefined, typeof GENERATE_TEARSHEET_FAILURE> {
  type: typeof GENERATE_TEARSHEET_FAILURE;
}

interface DocumentAnnouncementLoading
  extends Bixby.Models.BixbyAction<undefined, typeof DOCUMENT_ANNOUNCEMENT_LOADING> {
  type: typeof DOCUMENT_ANNOUNCEMENT_LOADING;
}

interface DocumentAnnouncementSuccess
  extends Bixby.Models.BixbyAction<string, typeof DOCUMENT_ANNOUNCEMENT_SUCCESS> {
  type: typeof DOCUMENT_ANNOUNCEMENT_SUCCESS;
  payload: string
}

interface DocumentAnnouncementFailure
  extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof DOCUMENT_ANNOUNCEMENT_FAILURE> {
  type: typeof DOCUMENT_ANNOUNCEMENT_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface MostRecentCompanyTaskLoading
  extends Bixby.Models.BixbyAction<undefined, typeof MOST_RECENT_COMPANY_TASK_LOADING> {
  type: typeof MOST_RECENT_COMPANY_TASK_LOADING;
}

interface MostRecentCompanyTaskSuccess
  extends Bixby.Models.BixbyAction<Bixby.Models.ClientCompanyTask, typeof MOST_RECENT_COMPANY_TASK_SUCCESS> {
  type: typeof MOST_RECENT_COMPANY_TASK_SUCCESS;
  payload: Bixby.Models.ClientCompanyTask;
}

interface MostRecentCompanyTaskFailure
  extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof MOST_RECENT_COMPANY_TASK_FAILURE> {
  type: typeof MOST_RECENT_COMPANY_TASK_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface ImportCompanies extends Bixby.Models.BixbyAction<undefined, typeof IMPORT_COMPANIES> {
  type: typeof IMPORT_COMPANIES;
}

interface ImportCompaniesSuccess extends Bixby.Models.BixbyAction<undefined, typeof IMPORT_COMPANIES_SUCCESS> {
  type: typeof IMPORT_COMPANIES_SUCCESS;
}

interface ImportCompaniesFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof IMPORT_COMPANIES_FAILURE> {
  type: typeof IMPORT_COMPANIES_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface ImportLFIIds extends Bixby.Models.BixbyAction<undefined, typeof IMPORT_LFI_IDS> {
  type: typeof IMPORT_LFI_IDS;
}

interface ImportLFIIdsSuccess extends Bixby.Models.BixbyAction<undefined, typeof IMPORT_LFI_IDS_SUCCESS> {
  type: typeof IMPORT_LFI_IDS_SUCCESS;
}

interface ImportLFIIdsFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof IMPORT_LFI_IDS_FAILURE> {
  type: typeof IMPORT_LFI_IDS_FAILURE;
  payload: Bixby.Models.BixbyError;
}

export type CompanyActionTypes =
  | SetCurrentCompany
  | CreateCompany
  | RemoveCompany
  | CompanyLoading
  | CompanyError
  | CompaniesLoading
  | CompaniesSuccess
  | CompaniesFailure
  | CompaniesClear
  | AddClientCompany
  | AddClientCompanySuccess
  | AddClientCompanyFailure
  | DeleteClientCompany
  | DeleteClientCompanySuccess
  | DeleteClientCompanyFailure
  | GeneratePrimer
  | GeneratePrimerSuccess
  | GeneratePrimerFailure
  | GenerateTearSheet
  | GenerateTearSheetSuccess
  | GenerateTearSheetFailure
  | LoginClearPreloadedData
  | AddClientCompanyTask
  | AddClientCompanyTaskSuccess
  | AddClientCompanyTaskFailure
  | AddPublicCompanyTask
  | AddPublicCompanyTaskSuccess
  | AddPublicCompanyTaskFailure
  | DocumentAnnouncementLoading
  | DocumentAnnouncementSuccess
  | DocumentAnnouncementFailure
  | MostRecentCompanyTaskLoading
  | MostRecentCompanyTaskSuccess
  | MostRecentCompanyTaskFailure
  | ImportCompanies
  | ImportCompaniesSuccess
  | ImportCompaniesFailure
  | ImportLFIIds
  | ImportLFIIdsSuccess
  | ImportLFIIdsFailure;
